// extracted by css-extract-rspack-plugin
export default {"hiddenPlaceholder":"Milestone-module__hiddenPlaceholder__lFLrl2A"};